import React from 'react'
import Tooltip from "components/Tooltip"
import "app/static/stylus/tooltip-i.styl"
import PropTypes from "prop-types"

// well this is stupid
const TooltipInfoCircle = ({ tooltipText }) =>
    <Tooltip label={tooltipText} placement="top">
        <i className="help-i fa fa-info-circle" />
    </Tooltip>


TooltipInfoCircle.propTypes = {
    tooltipText: PropTypes.string.isRequired,
}

export default TooltipInfoCircle
